var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-cascader',{ref:"selectArea",attrs:{"options":_vm.area_list,"clearable":""},on:{"change":_vm.selectAreaChange},model:{value:(_vm.self_area_ids),callback:function ($$v) {_vm.self_area_ids=$$v},expression:"self_area_ids"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a30ced40","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/Contract/components/SelectArea.vue
// module id = null
// module chunks = 